import Vue from 'vue'
import App from './AppShell.vue'
import router from './router'
import axios from 'axios'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueTypedJs from 'vue-typed-js'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const sessionApiBases = [
  process.env.VUE_APP_API_BASE,
  process.env.VUE_APP_SHEET_API_BASE,
  "https://api.ntustmeg.com",
  "https://devapi.ntustmeg.com",
  "http://127.0.0.1:8081",
  "http://localhost:8081",
].filter(Boolean);

const isSessionApiRequest = (config = {}) => {
  const url = config.url || "";
  return (
    sessionApiBases.some((base) => url.startsWith(base)) ||
    (config.baseURL &&
      sessionApiBases.some((base) => config.baseURL.includes(base)))
  );
};

const isLoginApiRequest = (config = {}) => {
  const requestUrl = `${config.baseURL || ""}${config.url || ""}`;
  return /\/api\/(student|admin)\/login(?:[/?#]|$)/.test(requestUrl);
};

const redirectToLoginWithChatQuery = () => {
  if (router.currentRoute.path === "/login") return;

  const currentQuery = router.currentRoute.query || {};
  const loginQuery = {};
  if (currentQuery.ch) loginQuery.ch = currentQuery.ch;
  if (currentQuery.room) loginQuery.room = currentQuery.room;
  if (String(currentQuery.ref || "").toLowerCase() === "noai") {
    loginQuery.ref = "noai";
    ["ch1", "ch2", "ch3"].forEach((key) => {
      if (currentQuery[key]) loginQuery[key] = currentQuery[key];
    });
  }

  router.replace({ path: "/login", query: loginQuery }).catch(() => {});
};

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("session_token");

    if (token && isSessionApiRequest(config)) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const config = error?.config || {};

    // 登入失敗的 401 只交給登入表單顯示，不得清除既有聊天室 Session。
    const shouldRelogin =
      status === 401 &&
      isSessionApiRequest(config) &&
      !isLoginApiRequest(config);

    if (shouldRelogin) {
      localStorage.removeItem("session_token");
      localStorage.removeItem("game_id");
      redirectToLoginWithChatQuery();
    } else if (status === 403) {
      // 403 代表已登入但沒有權限，不得清除 Session。
      alert(error?.response?.data?.message || "沒有此操作權限");
    }
    return Promise.reject(error);
  }
);

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
Vue.use(VueTypedJs)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
